// Definição para o modal de busca de Autoridades Tributárias
// Variação de parceiroSearch para busca de Órgãos de Governo (Federal/Estadual/Municipal/Comitê Gestor)
// Factory function - recebe idEmpresa e lstEsferaGovernamental como parâmetros

import { PARCEIRO_ESFERA_GOV } from '@/constants/PARCEIRO_ESFERA_GOV'

export const criarConfigBuscaParceiroAutoridadeTributaria = (idOrganizacao, lstEsferaGovernamental) => {
  const tituloMap = {
    [PARCEIRO_ESFERA_GOV.Federal]: 'Pesquisar Órgão Federal',
    [PARCEIRO_ESFERA_GOV.Estadual]: 'Pesquisar Órgão Estadual',
    [PARCEIRO_ESFERA_GOV.Municipal]: 'Pesquisar Órgão Municipal',
    [PARCEIRO_ESFERA_GOV.ComiteGestor]: 'Pesquisar Comitê Gestor do IBS'
  }

  return {
    label: 'Autoridade Tributária',
    placeholder: 'Nome ou Documento...',
    titulo: tituloMap[lstEsferaGovernamental] || 'Pesquisar Autoridade Tributária',
    endpointApi: 'Parceiros',
    idField: 'idParceiro',
    displayField: 'idParceiro',
    descField: 'nomeFantasia',
    camposFiltro: [
      { model: 'busca', label: 'Nome ou Documento', tipo: 'text' },
      { model: 'isOrgaoGoverno', label: 'Órgão de Governo', tipo: 'hidden', value: true },
      { model: 'lstEsferaGovernamental', label: 'Esfera', tipo: 'hidden', value: lstEsferaGovernamental },
      { model: 'idOrganizacao', label: 'Empresa', tipo: 'hidden', value: idOrganizacao }
    ],
    colunasGrid: [
      { header: 'Nome Fantasia', dataField: 'nomeFantasia', width: '70%' },
      { header: 'Documento', dataField: 'documento', width: '30%' }
    ]
  }
}
